import React from 'react';
import { DeviceCard } from './DeviceCard';
import { PlugIcon, AirVentIcon, ThermometerIcon, PlusIcon } from 'lucide-react';
export function DeviceGrid() {
  const devices = [{
    id: 1,
    name: 'Smart Plug Lite',
    type: 'plug',
    location: 'Living Room',
    status: 'on',
    power: '45W',
    icon: PlugIcon
  }, {
    id: 2,
    name: 'Smart Plug Lite',
    type: 'plug',
    location: 'Kitchen',
    status: 'on',
    power: '120W',
    icon: PlugIcon
  }, {
    id: 3,
    name: 'IR AC Pod',
    type: 'ac',
    location: 'Bedroom',
    status: 'off',
    temperature: '24°C',
    icon: AirVentIcon
  }, {
    id: 4,
    name: 'Temperature Sensor',
    type: 'sensor',
    location: 'Bathroom',
    status: 'on',
    reading: '22°C',
    icon: ThermometerIcon
  }];
  return <div className="mb-6" data-id="element-156">
      <div className="flex justify-between items-center mb-4" data-id="element-157">
        <h2 className="text-xl font-semibold" data-id="element-158">Connected Devices</h2>
        <button className="px-3 py-1 bg-green-600 text-white rounded-lg text-sm flex items-center hover:bg-green-700" data-id="element-159">
          <PlusIcon size={16} className="mr-1" data-id="element-160" />
          Add Device
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-161">
        {devices.map(device => <DeviceCard key={device.id} device={device} data-id="element-162" />)}
      </div>
    </div>;
}